// import themeConfig from "@/../themeConfig.js";
// import colors from "@/../themeConfig.js";

export default {
    breadcrumb: {
        title: "",
        list: [{ name: "" }]
	},
	unreadNotifications: [],
	fitrosCalendarioPrazos: {
		responsaveis: [],
		status: [],
		apenasMeusSupervisionados: false
	},
	prazoToEditar: null,
};
